import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ProjectTemplateBody from "components/AdministrationComponents/ProjectTemplate/ProjectTemplateBody";

const ProjectTemplates = () => {
  useEffect(() => {
    document.title = "Administration | Project Template";
  }, []);

  return (
    <main id="app">
      <Header moduleName="administration" />
      <ProjectTemplateBody />
    </main>
  );
};

export default ProjectTemplates;
